/**
 * Base URL ของ backend (ตัด slash ท้ายออก) จาก VUE_APP_API_URL
 */
export function getVueAppApiBaseUrl(): string {
  return String(process.env.VUE_APP_API_URL || "")
    .trim()
    .replace(/\/+$/, "");
}

/**
 * ต่อ VUE_APP_API_URL กับ path (รองรับ base มีหรือไม่มี slash ท้าย)
 */
export function buildApiUrl(path: string): string {
  const base = getVueAppApiBaseUrl();
  if (!base) return "";
  const p = String(path || "").replace(/^\/+/, "");
  return `${base}/${p}`;
}
